/**
 * Fenster in der Bildschirmmitte. Ersetzt Klapplisten und Systemdialoge:
 * die haengen an der Zeile, werden vom Rand abgeschnitten und sehen auf jedem
 * System anders aus. Siehe Vault, Werkzeugansichten Designmuster.
 */
import { useEffect, type ReactNode } from 'react'

interface Eigenschaften {
  titel: string
  offen: boolean
  aufSchliessen: () => void
  children: ReactNode
  /** Breiter fuer Formulare mit vielen Feldern nebeneinander. */
  breit?: boolean
}

export function Fenster({ titel, offen, aufSchliessen, children, breit = false }: Eigenschaften) {
  useEffect(() => {
    if (!offen) return
    const beiTaste = (ereignis: KeyboardEvent) => {
      if (ereignis.key === 'Escape') aufSchliessen()
    }
    document.addEventListener('keydown', beiTaste)
    document.body.style.overflow = 'hidden'
    return () => {
      document.removeEventListener('keydown', beiTaste)
      document.body.style.overflow = ''
    }
  }, [offen, aufSchliessen])

  if (!offen) return null

  return (
    <div className="fenster-grund" onClick={aufSchliessen} role="presentation">
      <div
        className={breit ? 'fenster breit' : 'fenster'}
        role="dialog"
        aria-modal="true"
        aria-label={titel}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="fenster-kopf">
          <h2>{titel}</h2>
          <button type="button" className="fenster-zu" onClick={aufSchliessen} aria-label="Schließen">
            ×
          </button>
        </div>
        <div className="fenster-inhalt">{children}</div>
      </div>
    </div>
  )
}
